import control from '@/components/users/control/storage';
import users from '@/components/users/users/storage';
import roles from '@/components/users/roles/storage';


export default {
    namespaced: true,
    modules: {
        control,
        users,
        roles
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}